import React, { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { isLoggedIn, notAuthorized } from "../../../api/AuthService"
import ReportSubmit from "./ReportSubmit"
import { exceptPdfDownload } from "../../../constant/Constants"
import textValidation from "./textValidation"
const selectedCheckboxes = new Set()
function PDFDownload(props) {
   const userRole=localStorage.getItem("role")
   const [data, setData] = useState({
      reportName: props.reportName,
      partName: "",
      pdfView:userRole === "CM"?"contractpackaging":"default",
      changeAction: "",
      reportCustomName: "",
      template: "",
      fileData: "",
      
   })
   const [dataAttributes,setDataAttributes]=useState({
      attributes:true,
      dgClassification:false,
      globalHarmonizedStandard:false,
      storageTransportationLabelingAssesmentData:false,
      stabilityDocument:false,
      batteryRollUp:false,
      warehouseClassification:false,
      ingredientTransparency:false,
      uniqueFormulaIdentifier:false,
      notes:false,
      marketOfSale:true,
      sAPBomAsFed:false,
      marketOfSale:false,
      billOfMaterialsIncludesSubstitutesAllCategories:true,
      performanceCharacteristics:false,
      relatedSpecifications:true,
      masterSpecifications:true,
      certifications:false,
      weightsDimensionsIncludesTransportPackingUnit:false,
      baseCodeSubstitute:false,
      relatedATS:false,
      MasterPIGendoc:false,
   })
   const [message, setMessage] = useState("")
   const [success, setSuccess] = useState(false)
   const [blinkSearch, setBlinkSearch] = useState("reportOptions")
   const totalItems=document.getElementsByClassName("pdfDownloadTabs").length
   const defaultChecked=document.getElementsByClassName("defaultChecked").length
   const handleRadioChange = (e) => {
      const { value } = e.target
      setData((data) => ({
         ...data,
         pdfView: value,
      }))
   }

   const handleTextChange = (e) => {
      e.preventDefault()
      setBlinkSearch("reportOptions")
      setMessage("")
      const textVal = textValidation(e.target.value, e.target.name)
      if (textVal.props.children || e.target.value === "") {
         const { name, value } = e.target
         setData((data) => ({
            ...data,
            [name]: value,
         }))
      }
   }

   const handleValidation = (code, msg) => {
      if (code === 999) {
         setSuccess(false)
         setMessage(
            "Please enter Part Names/Change Actions OR upload an Input File to request a report."
         )
         setBlinkSearch("highlightFields")
      } else if (code === 200) {
         setSuccess(true)
         setMessage(
            "Your Report will be processed in the background and will complete shortly. Please refresh the screen after few minutes"
         )
      } else if (code === 422 || code === 429 || code === 417 || code === 501) {
         setSuccess(false)
         setMessage(msg)
      } else if (code === 401) {
         notAuthorized(props.navigate)
      } else if (code === 423) {
         setSuccess(false)
         setMessage(
            "The maximum number of In process report requests (5) has been reached. Please submit another report later."
         )
      } else {
         setSuccess(false)
         setMessage("Report submission failed. Please contact SpecReaderExt.im@pg.com for help.")
      }
   }

   const clearMsg = () => {
      setMessage("")
   }

   const handleClearItems = () => {
      document.getElementById("view").value = "0"
      props.clearItem()
   }

   const fileValidation = (e) => {
      e.preventDefault()
      const filePath = e.target.value
      // Allowing file type
      var allowedExtensions = /(\.txt)$/i

      if (!allowedExtensions.exec(filePath)) {
         alert("Invalid file type. Please upload a text file.")
         e.target.value = ""
         setData((data) => ({
            ...data,
            fileData: "",
         }))
         return false
      }
      const reader = new FileReader()
      reader.onload = async (e) => {
         const text = e.target.result
         const removeNewLine = text.replace(/[\n]+/g, ",")
         const formatedText = removeNewLine.replace(/[\t]/g, " ")
         const textOnly = formatedText.replace(/[^a-zA-Z0-9 ,-]/g, "")
         setData((data) => ({
            ...data,
            fileData: textOnly
         }))
      }
      reader.readAsText(e.target.files[0])
   }

   const handleClearFile =(e) =>{
      e.preventDefault()
      var file = document.getElementById('file')
      file.value=''
      setData((data) => ({
         ...data,
         fileData: ''
      }))
   }
   const handleCheckbox = (e) => {
      setMessage("")
      const target = e.target
      const checked = target.checked
      const name = target.name
      if (name === "allCategories"){
         for (const key of Object.keys(dataAttributes)) {
            if (!exceptPdfDownload.includes(key)) {
               setDataAttributes((dataAttributes) => ({
                  ...dataAttributes,
                  [key]: checked,
               }))
               if (checked) {
                  if (!selectedCheckboxes.has(key)) {
                     selectedCheckboxes.add(key)
                  }
               } else {
                  selectedCheckboxes.clear()
               }
            }
         }
      }
      else {
         setDataAttributes((dataAttributes) => ({
            ...dataAttributes,
            [name]: checked,
            allCategories: false,
         }))

         if (checked) {
            if (!selectedCheckboxes.has(name)) {
               selectedCheckboxes.add(name)
            }
         } else {
            selectedCheckboxes.delete(name)
         }
         selectedCheckboxes.delete("allCategories")
         if([...selectedCheckboxes].length === (totalItems - defaultChecked)){
            setDataAttributes((dataAttributes) => ({
               ...dataAttributes,
               allCategories: true,
            }))
         }
      }
   }

   useEffect(() => {
      if (!isLoggedIn()) {
         props.navigate("/")
      } else {
         setData((data) => ({
            ...data,
            partName: props.templateData.partName ? props.templateData.partName : "",
            pdfView: props.templateData.pdfView ? props.templateData.pdfView:data.pdfView,
            changeAction: props.templateData.changeAction ? props.templateData.changeAction : "",
            reportCustomName: props.templateData.reportCustomName ? props.templateData.reportCustomName : "",
            reportName: props.reportName ? props.reportName : "", 
            
         }))

         setDataAttributes((dataAttributes) => ({
            ...dataAttributes,
            allCategories:props.templateData.allCategories?props.templateData.allCategories:false,
            dgClassification:props.templateData.dgClassification?props.templateData.dgClassification:false,
            globalHarmonizedStandard:props.templateData.globalHarmonizedStandard?props.templateData.globalHarmonizedStandard:false,
            storageTransportationLabelingAssesmentData:props.templateData.storageTransportationLabelingAssesmentData?props.templateData.storageTransportationLabelingAssesmentData:false,
            stabilityDocument:props.templateData.stabilityDocument?props.templateData.stabilityDocument:false,
            batteryRollUp:props.templateData.batteryRollUp?props.templateData.batteryRollUp:false,
            warehouseClassification:props.templateData.warehouseClassification?props.templateData.warehouseClassification:false,
            notes:props.templateData.notes?props.templateData.notes:false,
            sAPBomAsFed:props.templateData.sAPBomAsFed?props.templateData.sAPBomAsFed:false,
            marketOfSale:props.templateData.marketOfSale?props.templateData.marketOfSale:false,
            performanceCharacteristics:props.templateData.performanceCharacteristics?props.templateData.performanceCharacteristics:false,
            
            certifications:props.templateData.certifications?props.templateData.certifications:false,
            weightsDimensionsIncludesTransportPackingUnit:props.templateData.weightsDimensionsIncludesTransportPackingUnit?props.templateData.weightsDimensionsIncludesTransportPackingUnit:false,
            relatedATS:props.templateData.relatedATS?props.templateData.relatedATS:false,
            baseCodeSubstitute:props.templateData.baseCodeSubstitute?props.templateData.baseCodeSubstitute:false,
            ingredientTransparency:props.templateData.ingredientTransparency?props.templateData.ingredientTransparency:false,
            uniqueFormulaIdentifier:props.templateData.uniqueFormulaIdentifier?props.templateData.uniqueFormulaIdentifier:false,
            MasterPIGendoc:props.templateData.MasterPIGendoc?props.templateData.MasterPIGendoc:false,
         }))
      }
   }, [props.templateData])

   return (
      <React.Fragment>
            <Row className="mb-3" id="pdfFormRadio">
         {userRole!=="SP" &&
               <Col sm="5" md="5">
                  <span className="reportLabels" id="impInput">PDF View</span>
               </Col>}
               
                  <Col sm="6" md="3">
                  {userRole==="" && (
                     <>
                     <Form.Check
                     type="radio"
                     label="Default Internal View"
                     name="pdfView"
                     id="default"
                     value="default"
                     onChange={handleRadioChange}
                     checked={data.pdfView === "default"}
                     />
                     <Form.Check
                     type="radio"
                     label="Supplier"
                     name="pdfView"
                     id="supplier"
                     value="supplier"
                     onChange={handleRadioChange}
                     checked={data.pdfView === "supplier"}
                     />
                      </>
                  )
                     }
                    {userRole!=="SP" && (<>
                     <Form.Check
                     type="radio"
                     label="Contract Manufacturing"
                     name="pdfView"
                     id="contractpackaging"
                     value="contractpackaging"
                     onChange={handleRadioChange}
                     checked={data.pdfView === "contractpackaging"}
                     />
                    <Form.Check
                     type="radio"
                     label="Consolidated Packaging View"
                     name="pdfView"
                     id="consolidatedpackaging"
                     value="consolidatedpackaging"
                     onChange={handleRadioChange}
                     checked={data.pdfView === "consolidatedpackaging"}
                     />
                    </>)} 
                  </Col>
            </Row>
            {data.pdfView==="consolidatedpackaging" && ( 
               <>
             <Row className="mb-3" id="partAndSpecFormlabel">
            <Col sm="11" md="11">
               <span className="reportLabels">PLEASE NOTE: Selecting All Categories will result in longer processing time.</span>
            </Col>
         </Row>
            <Row className="mb-3" id="allCategories">
            <Col sm="5" md="5">
               <span className="reportLabels">All Categories</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  name="allCategories"
                  onChange={handleCheckbox}
                  checked={dataAttributes.allCategories}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="attributes">
            <Col sm="5" md="5">
               <span className="reportLabels">Attributes</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Check
                  type="checkbox"
                  className="pdfDownloadTabs defaultChecked"
                  name="attributes"
                  onChange={handleCheckbox}
                  checked={true} disabled 
               />
            </Col>
         </Row>
            <Row className="mb-3" id="dgClassification">
               <Col sm="5" md="5">
                  <span className="reportLabels">Dangerous Goods Classification</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="dgClassification"
                     onChange={handleCheckbox}
                     checked={dataAttributes.dgClassification}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="globalHarmonizedStandard">
               <Col sm="5" md="5">
                  <span className="reportLabels">Global Harmonized Standard</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="globalHarmonizedStandard"
                     onChange={handleCheckbox}
                     checked={dataAttributes.globalHarmonizedStandard}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="storageTransportationLabelingAssesmentData">
               <Col sm="5" md="5">
                  <span className="reportLabels">Storage, Transportation, Labeling Assessment Data</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="storageTransportationLabelingAssesmentData"
                     onChange={handleCheckbox}
                     checked={dataAttributes.storageTransportationLabelingAssesmentData}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="stabilityDocument">
               <Col sm="5" md="5">
                  <span className="reportLabels">Stability Document</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="stabilityDocument"
                     onChange={handleCheckbox}
                     checked={dataAttributes.stabilityDocument}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="batteryRollUp">
               <Col sm="5" md="5">
                  <span className="reportLabels">Battery Roll Up & Calculation</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="batteryRollUp"
                     onChange={handleCheckbox}
                     checked={dataAttributes.batteryRollUp}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="warehouseClassification">
               <Col sm="5" md="5">
                  <span className="reportLabels">Warehouse Classification</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="warehouseClassification"
                     onChange={handleCheckbox}
                     checked={dataAttributes.warehouseClassification}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="ingredientTransparency">
               <Col sm="5" md="5">
                  <span className="reportLabels">Ingredient Transparency</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="ingredientTransparency"
                     onChange={handleCheckbox}
                     checked={dataAttributes.ingredientTransparency}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="uniqueFormulaIdentifier">
               <Col sm="5" md="5">
                  <span className="reportLabels">Unique Formula Identifier</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="uniqueFormulaIdentifier"
                     onChange={handleCheckbox}
                     checked={dataAttributes.uniqueFormulaIdentifier}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="notes">
               <Col sm="5" md="5">
                  <span className="reportLabels">Notes</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="notes"
                     onChange={handleCheckbox}
                     checked={dataAttributes.notes}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="sAPBomAsFed">
               <Col sm="5" md="5">
                  <span className="reportLabels">SAP BOM as Fed</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="sAPBomAsFed"
                     onChange={handleCheckbox}
                     checked={dataAttributes.sAPBomAsFed}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="marketOfSale">
               <Col sm="5" md="5">
                  <span className="reportLabels">Market of Sale</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="marketOfSale"
                     onChange={handleCheckbox}
                     checked={dataAttributes.marketOfSale}
                  />
               </Col>
        </Row>
        
        
        <Row className="mb-3" id="billOfMaterialsIncludesSubstitutesAllCategories">
               <Col sm="5" md="5">
                  <span className="reportLabels">Bill of Materials (includes Substitutes) - all categories</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs defaultChecked"
                     name="billOfMaterialsIncludesSubstitutesAllCategories"
                     onChange={handleCheckbox}
                     checked={true} disabled 
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="performanceCharacteristics">
               <Col sm="5" md="5">
                  <span className="reportLabels">Performance Characteristic</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="performanceCharacteristics"
                     onChange={handleCheckbox}
                     checked={dataAttributes.performanceCharacteristics}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="relatedSpecifications">
               <Col sm="5" md="5">
                  <span className="reportLabels">Related Specifications</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs defaultChecked"
                     name="relatedSpecifications"
                     onChange={handleCheckbox}
                     checked={true} disabled
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="masterSpecifications">
               <Col sm="5" md="5">
                  <span className="reportLabels">Master Specifications</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs defaultChecked"
                     name="masterSpecifications"
                     onChange={handleCheckbox}
                     checked={true} disabled
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="certifications">
               <Col sm="5" md="5">
                  <span className="reportLabels">Certifications</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
className="pdfDownloadTabs"
                     name="certifications"
                     onChange={handleCheckbox}
                     checked={dataAttributes.certifications}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="weightsDimensionsIncludesTransportPackingUnit">
               <Col sm="5" md="5">
                  <span className="reportLabels">Weights & Dimensions (includes Packing and Transport Units)</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="weightsDimensionsIncludesTransportPackingUnit"
                     onChange={handleCheckbox}
                     checked={dataAttributes.weightsDimensionsIncludesTransportPackingUnit}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="baseCodeSubstitute">
               <Col sm="5" md="5">
                  <span className="reportLabels">Base Code & Substitute Base Code Details</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="baseCodeSubstitute"
                     onChange={handleCheckbox}
                     checked={dataAttributes.baseCodeSubstitute}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="relatedATS">
               <Col sm="5" md="5">
                  <span className="reportLabels">Related ATS</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="relatedATS"
                     onChange={handleCheckbox}
                     checked={dataAttributes.relatedATS}
                  />
               </Col>
        </Row>
        <Row className="mb-3" id="MasterPIGendoc">
               <Col sm="5" md="5">
                  <span className="reportLabels">Master PI(s) Gendocs</span>
               </Col>
               <Col sm="6" md="6">
                  <Form.Check
                     type="checkbox"
                     className="pdfDownloadTabs"
                     name="MasterPIGendoc"
                     onChange={handleCheckbox}
                     checked={dataAttributes.MasterPIGendoc}
                  />
               </Col>
        </Row>
        </>)}
         <Row className="mb-3" id="pdfFormlabel">
            <Col sm="11" md="11">
               <span className="reportLabels">
                  Please enter Part name(s) and/or Change Action(s) below <b>OR</b> upload a
                  .txt file containing Part Name(s) and/or Change Action(s).
               </span>
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormPart">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Part Name</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Control
                  as="textarea"
                  name="partName"
                  value={data.partName}
                  rows={3}
                  onChange={handleTextChange}
                  className={`${blinkSearch}`}
                  style={{ minHeight: "3rem" }}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormChangeAction">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Change Action</span>
            </Col>
            <Col sm="6" md="6">
               <Form.Control
                  as="textarea"
                  name="changeAction"
                  value={data.changeAction}
                  rows={3}
                  onChange={handleTextChange}
                  className={`${blinkSearch}`}
                  style={{ minHeight: "3rem" }}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormInput">
            <Col sm="5" md="5">
               <span className="reportLabels" id="impInput">Input File(ANSI .txt files only)</span>
            </Col>
            <Col sm="6" md="6">
               <input type="file" id="file" onChange={fileValidation} />
               <Button variant="primary" onClick={handleClearFile}>
                  Clear
               </Button>
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormCustomnName">
            <Col sm="5" md="5">
               <span className="reportLabels">Report Custom Name</span>
            </Col>
            <Col sm="6" md="6" mt="2">
               <Form.Control
                  as="input"
                  name="reportCustomName"
                  value={data.reportCustomName}
                  rows={3}
                  className="reportOptions"
                  onChange={handleTextChange}
               />
            </Col>
         </Row>
         <Row className="mb-3" id="pdfFormTemplate">
            <Col sm="5" md="5">
               <span className="reportLabels">Save as Template (New Template will be created)</span>
            </Col>
            <Col sm="6" md="6" mt="2">
               <Form.Control
                  as="input"
                  name="template"
                  value={data.template}
                  rows={3}
                  className="reportOptions"
                  onChange={handleTextChange}
               />
            </Col>
         </Row>
         <Row>
            <Col md="11" sm="11" align="center">
               <p style={{ marginTop: "4px", fontWeight: "bold" }} className={(success ? 'successMsg' : 'alertMsg')}>
                  {message}
               </p>
            </Col>
         </Row>
         <br />
         <ReportSubmit
            data={data.pdfView==="consolidatedpackaging" ? {...dataAttributes,...data}:{...data}}
            handleClearItems={handleClearItems}
            handler={handleValidation}
            clearMsg={clearMsg}
         />
         <br />
      </React.Fragment>
   )
}
export default PDFDownload